import type { PropType } from 'vue';
import { ViewTypes } from '~/constants/ui.constants';
import { getFromState } from '~/composables';
import { Component } from '~/types';
import { mapBlog } from '~/units/blogs/store';
import { BlogItem, SingleBlog, SingleBlogRepo } from '~/units/blogs/types';

export const BlogMixin = defineNuxtComponent({
  props: {
    component: {
      required: true,
      type: Object as PropType<Component>,
    },
  },

  data() {
    return {
      ViewTypes,
    };
  },

  computed: {
    singleBlogRepoRef() {
      const data = getFromState('singleBlogRepo') as SingleBlogRepo;
      const route = useRoute();
      const identifier = route.params.blog_id;

      if (data && data.length > 0) {
        return data.find((item) => item.identifier === identifier);
      }
      return null;
    },

    blog() {
      const blog = <SingleBlog>this.singleBlogRepoRef;

      if (blog && blog.data) {
        const item: BlogItem = blog.data;
        return mapBlog(item);
      }
      return null;
    },
  },
});
